import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardUnsubscribeSummary = () => {
    const send = useGenericSend();

    return useCallback(async () => {
        const response = await send({
            ID: 71013,
            responses: [71014, 71015],
            description: 'Unsubscribe Leaderboards Summary notifications'
        });

        return response;
    }, [send]);
};
